import { Button, Icon } from '@genial/components';
import { Color } from '@genial/design-tokens';
import React from 'react';

export namespace CancelButtonTypes {
  export interface Props {
    onPress?: VoidFunction;
    isDisabled?: boolean;
  }
}

export const CancelButton: React.FC<CancelButtonTypes.Props> = ({ onPress, isDisabled }) => {
  return (
    <Button
      onPress={onPress}
      isDisabled={isDisabled}
      variant="textLink"
      testID="withdralwal-receipt-cancel-button"
      _text={{ color: isDisabled ? Color['neutral.medium'] : Color['feedback.error.default'] }}
      rightIcon={
        <Icon
          name="Trash"
          size="xxs"
          color={isDisabled ? Color['neutral.medium'] : Color['feedback.error.default']}
          testID="withdralwal-receipt-cancel-button-icon"
        />
      }
      alignSelf="flex-start">
      CANCELAR
    </Button>
  );
};
